import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=224bb738&scoped=true&"
import script from "./ProgramCard.vue?vue&type=script&lang=ts&"
export * from "./ProgramCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=224bb738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bb738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
